module.exports = __webpack_public_path__ + "static/media/capa-comparativo-mobile.f5da175f.png";